const isDev = () => {
    try {
        return process.env.NODE_ENV && process.env.NODE_ENV === 'development';
    } catch (e) {
        return false;
    }
}

export default isDev;

const isTestEndpoint = () => {
    if(window.location.pathname.indexOf('-testing') !== -1) {
        return true;
    }

    /*
    if(isDev()) {
        return true;
    }
    */

    return false;
};

export {isTestEndpoint};
